import React, { useEffect } from 'react';
import { Link, useHistory } from 'react-router-dom';
import { Container, Row, Col } from 'react-bootstrap';
import { Styles } from "../styles/mobileMenu.js";

function MobileMenuDefault({navLinks}) {
    const history = useHistory();

    const handleNavClick = (href, hasSubMenu, event) => {
        // If it doesn't have a submenu, handle navigation
        if (!hasSubMenu) {
            event.preventDefault();
            const fullPath = process.env.PUBLIC_URL + href;
            // Close the mobile sidebar
            const mdSidebarOverlay = document.getElementById("mb-sidebar-overlay");
            const mdSidebarBody = document.getElementById("mb-sidebar-body");
            if (mdSidebarOverlay && mdSidebarBody) {
                mdSidebarOverlay.classList.remove("visible");
                mdSidebarBody.classList.remove("opened");
            }
            // Navigate to the page
            history.push(fullPath);
        }
    };

    useEffect(() => {
        // Mobile Menu
        const hmBtn = document.getElementById("mb-sidebar-btn");

        if (hmBtn) {
            const mdSidebarOverlay = document.getElementById("mb-sidebar-overlay");
            const mdSidebarBody = document.getElementById("mb-sidebar-body");
            const mdSidebarExit = document.getElementById("close-mb-sidebar");

            hmBtn.addEventListener("click", function (e) {
                e.preventDefault();
                mdSidebarOverlay.classList.toggle("visible");
                mdSidebarBody.classList.toggle("opened");
            });

            mdSidebarOverlay.addEventListener("click", function (e) {
                e.preventDefault();
                mdSidebarOverlay.classList.remove("visible");
                mdSidebarBody.classList.remove("opened");
            });

            mdSidebarExit.addEventListener("click", function (e) {
                e.preventDefault();
                mdSidebarOverlay.classList.remove("visible");
                mdSidebarBody.classList.remove("opened");
            });
        }

        // Menu Accordion -----------------
        const menuButton = document.querySelectorAll(".mb-menu-button");
        menuButton.forEach(button => {
            button.addEventListener("click", () => {
                // Check if this is a menu item with submenu
                const hasSubmenu = button.nextElementSibling && 
                                  button.nextElementSibling.classList.contains("mb-menu-content");
                
                if (hasSubmenu) {
                    // Handle accordion behavior for items with submenu
                    button.classList.toggle("active");
                    const content = button.nextElementSibling;

                    if (button.classList.contains("active")) {
                        content.className = "mb-menu-content show";
                        content.style.maxHeight = content.scrollHeight + "px";
                    } else {
                        content.className = "mb-menu-content";
                        content.style.maxHeight = "0";
                    }
                } else {
                    // For items without submenu, find the data-href attribute and navigate
                    const href = button.getAttribute("data-href");
                    if (href) {
                        const fullPath = process.env.PUBLIC_URL + href;
                        
                        // Close the mobile sidebar
                        const mdSidebarOverlay = document.getElementById("mb-sidebar-overlay");
                        const mdSidebarBody = document.getElementById("mb-sidebar-body");
                        if (mdSidebarOverlay && mdSidebarBody) {
                            mdSidebarOverlay.classList.remove("visible");
                            mdSidebarBody.classList.remove("opened");
                        }
                        
                        // Navigate to the page
                        history.push(fullPath);
                    }
                }
            });
        });
    }, [history]);

    return (
        <Styles>
            {/* Mobile Menu */}
            <section className="mobile-menu-area">
                <Container>
                    <Row>
                        <Col md="0" sm="12">
                            <div className="mb-topbar d-flex justify-content-between">
                                <div className="topbar-item">
                                    <p><i className="las la-phone"></i>04869 223 422</p>
                                </div>
                            </div>
                            <div className="mb-logo-area d-flex justify-content-between">
                                <div className="mb-logo-box d-flex">
                                    <div className="hm-button">
                                        <a href="/" id="mb-sidebar-btn">
                                            <i className="las la-bars"></i>
                                        </a>
                                    </div>
                                    <div className="mb-logo">
                                        <Link to={process.env.PUBLIC_URL + "/"}><img src={process.env.PUBLIC_URL + "/assets/images/footerlogo2.png"} alt="" /></Link>
                                    </div>
                                </div>
                            </div>
                        </Col>
                    </Row>
                </Container>
            </section>

            {/* Mobile Menu Sidebar */}
            <section className="mb-sidebar" id="mb-sidebar-body">
                <div className="mb-sidebar-heading d-flex justify-content-between">
                    <h5>Menu</h5>
                    <a href="/" id="close-mb-sidebar"><i className="las la-times"></i></a>
                </div>
                <div className="mb-sidebar-menu">
                    {navLinks.map((menu, index) => (
                        <div className="mb-menu-item" key={index}>
                            {menu.subMenu ? (
                                // Menu item with submenu
                                <>
                                    <button className="mb-menu-button">
                                        <p>{menu.name} <i className="las la-plus"></i></p>
                                    </button>
                                    <div className="mb-menu-content">
                                        <ul className="list-unstyled">
                                            {menu.subMenu.map((sub, idx) => (
                                                <li key={idx}>
                                                    <a href="#!" onClick={(e) => handleNavClick(sub.href, false, e)}>
                                                        {sub.name}
                                                    </a>
                                                </li>
                                            ))}
                                        </ul>
                                    </div>
                                </>
                            ) : (
                                // Menu item without submenu - make it directly clickable
                                <button 
                                    className="mb-menu-button no-submenu" 
                                    data-href={menu.href}
                                    onClick={(e) => handleNavClick(menu.href, false, e)}
                                >
                                    <p>{menu.name}</p>
                                </button>
                            )}
                        </div>
                    ))}
                </div>
            </section>
            <div className="mb-sidebar-overlay" id="mb-sidebar-overlay"></div>
        </Styles>
    )
}

export default MobileMenuDefault;